export default __webpack_public_path__ + "static/media/twitterprimera.0609bee2.svg";